import { Edit, Eye, Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
// import config from "../../../config";
import HeaderModule from "../../components/Header/HeaderModule";
import { useSelector } from "react-redux";
// import moment from "moment";
import { useCheckUserPermission } from "../../common/userPermission";
// import config from "../../../config";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { dateFormat } from "../../common/common";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

const businessOnboardingDelete = "businessOnboardingDelete";

const BusinessOnboardList = () => {
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  const user_data = useSelector((state) => state.user_data);
  const loginUserID = user_data?.id;
  const route = all_routes;
  const [serviceOption, setserviceOption] = useState([]);
  //  const [Categorylist, setCategorylist] = useState([]);
  const [priceType, setpriceType] = useState([]);
  const [dropdownOptions, setdropdownOptions] = useState([]);
  // const [staffList, setStaffList] = useState([]);
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);
  const [loading, setLoading] = useState(false);


  //     console.log(staffList, "staffList")

  const fileInputRef = useRef(null);


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return alert("Please select a file to upload");

    if (!file.name.endsWith(".xlsx")) {
      alert("Please upload only Excel (.xlsx) files");
      return;
    }

    try {
      MySwal.fire({
        title: "Processing...",
        text: "Please wait while we process your Excel file",
        allowOutsideClick: false,
        didOpen: () => MySwal.showLoading(),
      });

      const businessId = selectedBusinessId;

      const [services, categories, teams] = await Promise.all([
        apiHandler({ method: "GET", route: "Superadmin/serviceAll" }),
        apiHandler({
          method: "GET",
          route: `Business/CategoryAll?businessId=${businessId}`,
        }),
        apiHandler({
          method: "GET",
          route: `Superadmin/TeamListbybusinessId?businessId=${businessId}`,
        }),
      ]);

      if (
        !services?.ResponseData ||
        !categories?.ResponseData ||
        !teams?.ResponseData
      ) {
        throw new Error("Failed to fetch reference data");
      }

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(await file.arrayBuffer());
      const sheet = workbook.worksheets[0];
      if (!sheet) throw new Error("No worksheet found");

      const rows = [];

      sheet.eachRow((row, rowNumber) => {
        if (rowNumber <= 2) return;

        const values = row.values.slice(1);
        if (values.every((v) => !v)) return;

        const [
          ServiceName,
          TeamPerson,
          ServiceType,
          ServiceCategory,
          MinDurationExcel,
          MaxDurationExcel,
          PriceTypeExcel,
          Price,
          IsHomeService,
        ] = values;

        const ServiceTypeObj = services.ResponseData.find(
          (s) =>
            s.Name?.toLowerCase().trim() ===
            ServiceType?.toLowerCase().trim()
        );

        const ServiceCategoryObj = categories.ResponseData.find(
          (c) =>
            c.categoryName?.toLowerCase().trim() ===
            ServiceCategory?.toLowerCase().trim()
        );

        const MinDurationObj = dropdownOptions.find(
          (d) =>
            d.label?.replace(/\s+/g, "").toLowerCase() ===
            MinDurationExcel?.replace(/\s+/g, "").toLowerCase()
        );

        const MaxDurationObj = dropdownOptions.find(
          (d) =>
            d.label?.replace(/\s+/g, "").toLowerCase() ===
            MaxDurationExcel?.replace(/\s+/g, "").toLowerCase()
        );

        if (
          MinDurationObj &&
          MaxDurationObj &&
          MinDurationObj.value > MaxDurationObj.value
        ) {
          throw new Error(
            `Min Duration cannot be greater than Max Duration for service: ${ServiceName}`
          );
        }

        const PriceTypeObj = priceType.find(
          (d) =>
            d.label?.replace(/\s+/g, "").toLowerCase() ===
            PriceTypeExcel?.replace(/\s+/g, "").toLowerCase()
        );

        const TeamPersonIDs = TeamPerson
          ? Array.from(
            new Set(
              TeamPerson.split(",")
                .map((name) => {
                  if (name.toLowerCase().trim() === "all") {
                    return teams.ResponseData.map((t) => t.id);
                  }
                  const person = teams.ResponseData.find(
                    (t) =>
                      t.fullName?.toLowerCase().trim() ===
                      name.toLowerCase().trim()
                  );
                  return person?.id || null;
                })
                .flat()
                .filter(Boolean)
            )
          )
          : [];

        rows.push({
          ServiceName: ServiceName || null,
          BusinessID: businessId,
          TeamPerson: TeamPersonIDs,
          ServiceType: ServiceTypeObj?.ID || null,
          ServiceCategory: ServiceCategoryObj?.ID || null,
          MinDuration: MinDurationObj?.value || null,
          MaxDuration: MaxDurationObj?.value || null,
          PriceType: PriceTypeObj?.value || null,
          Price: parseFloat(Price) || 0,
          IsHomeService:
            IsHomeService?.toString().toLowerCase() === "yes" ? 1 : 0,
        });
      });

      MySwal.close();

      if (!rows.length) throw new Error("No valid rows found");

      const payload = {
        jsonBulkServiceInsert: JSON.stringify({
          MultiserviceJson: rows,
        }),
        loginUserID,
      };

      const response = await apiHandler({
        method: "POST",
        route: "Business/businessServiceUpsertBulk",
        payload,
        headers: { "Content-Type": "application/json" },
      });

      const data = response?.ResponseID?.[0]?.FinalData || {};

      if (response?.ResponseCode === "SUCCESS") {
        MySwal.fire({
          icon: "success",
          title: `${data.SuccessfullyInserted || 0} Services Inserted`,
          text:
            data.DuplicatesSkipped > 0
              ? `Skipped: ${data.DuplicatesSkipped} | ${data.DuplicateServiceNames}`
              : "",
        });
      } else {
        throw new Error(response?.ResponseMessage || "Upload failed");
      }

      event.target.value = "";
    } catch (error) {
      console.error(error);
      MySwal.fire({
        icon: "error",
        title: "Upload Error",
        text: error.message || "Failed to process Excel",
      });
    }
  };



  const getBussinessTeam = async (businessId) => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Superadmin/TeamListbybusinessId?businessId=${businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }
      const data = serviceData?.ResponseData.map((el) => {
        return {
          value: el.id,
          label: el.fullName,
        };
      });
      const allOption = {
        value: "all",
        label: "All",
      };
      // setStaffList(data)
      return [allOption, ...data];
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  const getBussinessCategories = async (businessId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/CategoryAll?businessId=${businessId}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      const category = response.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.categoryName,
      }));
      // setCategorylist(category)
      return category; // return instead of setting state
    } else {
      console.log(response, "data");
      return [];
    }
  };

  async function fetchServices() {
    try {
      const responses = await apiHandler({
        method: "GET",
        route: "Superadmin/serviceAll",
      });

      if (responses.ResponseCode === "SUCCESS") {
        const category = responses.ResponseData?.map((u) => ({
          value: u.ID,
          label: u.Name,
        }));
        setserviceOption(category);
      }
    } catch (error) {
      console.error(error);
    }

    const priceTypes = await apiHandler({
      method: "GET",
      route: "Superadmin/priceTypeAll",
    });
    if (priceTypes.ResponseCode === "SUCCESS") {
      console.log(priceTypes, "data");
      const category = priceTypes.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setpriceType(category);
    } else {
      console.log(priceTypes, "data");
    }

    const Duration = await apiHandler({
      method: "GET",
      route: "Business/ServiceDurationAll",
    });
    if (Duration.ResponseCode === "SUCCESS") {
      console.log(Duration, "data");
      const category = Duration.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setdropdownOptions(category);
    } else {
      console.log(Duration, "data");
    }
  }

  useEffect(() => {
    fetchServices();
  }, []);

  const isHomeService = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  const handleDownload = async (
    businessId,
    BusinessName,
    businessUniqueName
  ) => {
    try {
      // 1️⃣ Fetch all required data
      const categories = await getBussinessCategories(businessId);
      const TeamData = await getBussinessTeam(businessId);

      if (!serviceOption?.length) {
        alert("No service data available to download.");
        return;
      }

      if (!categories?.length) {
        alert("No category data available to download.");
        return;
      }

      if (!dropdownOptions?.length) {
        alert("No duration data available to download.");
        return;
      }

      if (!priceType?.length) {
        alert("No price type data available to download.");
        return;
      }

      if (!isHomeService?.length) {
        alert("No Home Service options available to download.");
        return;
      }

      if (!TeamData?.length) {
        alert("No team data available to download.");
        return;
      }

      // 2️⃣ Create Excel workbook and sheet
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Services");

      // Business Name (merged header)
      sheet.mergeCells("A1:H1");
      const businessCell = sheet.getCell("A1");
      businessCell.value = BusinessName || "Business Name";
      businessCell.font = { bold: true, size: 14, color: { argb: "FF000000" } };
      businessCell.alignment = { vertical: "middle", horizontal: "center" };

      // Headers (removed "Business ID")
      const headers = [
        "Service Name",
        "Team Person",
        "Service Type",
        "Service Category",
        "Min Duration",
        "Max Duration",
        "Price Type",
        "Price",
        "Is Home Service",
      ];

      const headerRow = sheet.addRow(headers);

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFB6C1" },
        };
        cell.font = { bold: true, color: { argb: "FF000000" }, size: 12 };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin", color: { argb: "FFD3D3D3" } },
          bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
          left: { style: "thin", color: { argb: "FFD3D3D3" } },
          right: { style: "thin", color: { argb: "FFD3D3D3" } },
        };
      });

      // Empty rows for data entry
      for (let i = 0; i < 1000; i++)
        sheet.addRow(["", "", "", "", "", "", "", "", ""]);

      // 3️⃣ Hidden sheets for dropdown sources
      const createHiddenSheet = (name, data) => {
        const ws = workbook.addWorksheet(name);
        data.forEach((d) => ws.addRow([d.label]));
        ws.state = "veryHidden";
      };

      createHiddenSheet("ServiceTypes", serviceOption);
      createHiddenSheet("Categories", categories);
      createHiddenSheet("Durations", dropdownOptions);
      createHiddenSheet("PriceTypes", priceType);
      createHiddenSheet("HomeService", isHomeService);
      createHiddenSheet("TeamPersons", TeamData);


      const serviceRange = `ServiceTypes!$A$1:$A$${serviceOption.length}`;
      const categoryRange = `Categories!$A$1:$A$${categories.length}`;
      const durationRange = `Durations!$A$1:$A$${dropdownOptions.length}`;
      const priceTypeRange = `PriceTypes!$A$1:$A$${priceType.length}`;
      const homeServiceRange = `HomeService!$A$1:$A$${isHomeService.length}`;
      const teamRange = `TeamPersons!$A$1:$A$${TeamData.length}`;


      for (let row = 3; row <= 1002; row++) {

        // Team Person (B)
        sheet.getCell(`B${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [teamRange],
        };

        // Service Type (C)
        sheet.getCell(`C${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [serviceRange],
        };

        // Category (D)
        sheet.getCell(`D${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [categoryRange],
        };

        // ✅ Min Duration (E)
        sheet.getCell(`E${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [durationRange],
          errorTitle: "Invalid Min Duration",
          error: "Please select a valid Min Duration",
        };

        // ✅ Max Duration (F)
        sheet.getCell(`F${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [durationRange],
          errorTitle: "Invalid Max Duration",
          error: "Please select a valid Max Duration",
        };

        // Price Type (G)
        sheet.getCell(`G${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [priceTypeRange],
        };

        // Home Service (I)
        sheet.getCell(`I${row}`).dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: [homeServiceRange],
        };
      }

      // 6️⃣ Styling
      sheet.columns.forEach((col) => (col.width = 22));
      sheet.getRow(1).height = 25;
      sheet.getRow(2).height = 25;

      // 7️⃣ Download the Excel
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer]),
        `${businessUniqueName}_Basic_Detail_Excel.xlsx`
      );
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };


  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };

  const showLoadingAlert = () => {
    MySwal.fire({
      title: "Deleting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        MySwal.showLoading(); // Show loading spinner
      },
    });
  };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "businessOnboarding",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    const noPlus = cleaned.replace("+", "");

    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      // sortingFn: "numeric",
    },
    {
      header: "Unique Name",
      accessorKey: "businessUniqueName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //   header: "Logo",
    //   accessorKey: "businessLogo",
    //   Cell: ({ row }) =>
    //     row.original.businessLogo ? (
    //       <img
    //         src={config.Imageurl + row.original.businessLogo}
    //         alt={row.original.businessName}
    //         style={{ width: "fit-content", height: "auto", objectFit: "cover" }}
    //       />
    //     ) : (
    //       ""
    //     ),
    // },
    {
      header: "Category Type",
      accessorKey: "businessTypeName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Description",
      accessorKey: "businessDescription",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 320,
      Cell: ({ cell }) => (
        <div
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "100%",
          }}
          title={cell.getValue()} // Show full text on hover
        >
          {cell.getValue()}
        </div>
      ),
    },

    {
      header: "Address",
      accessorKey: "businessAddress",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 320,
      Cell: ({ cell }) => (
        <div
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "100%",
          }}
          title={cell.getValue()} // Show full text on hover
        >
          {cell.getValue()}
        </div>
      ),
    },
    {
      header: "Opening Date",
      accessorKey: "openingDate",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) =>
        <span>{dateFormat(row.original.openingDate)}</span>
      // new Date(row.original.openingDate).toLocaleDateString(),
    },
    {
      header: "Phone",
      accessorKey: "phoneNumber",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ cell }) => formatDBPhoneNumber(cell.getValue()),
    },
    {
      header: "Email",
      accessorKey: "emailAddress",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "WhatsApp",
      accessorKey: "whatsappNumber",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ cell }) => formatDBPhoneNumber(cell.getValue()),
    },
    {
      header: "Website",
      accessorKey: "websiteURL",
      Cell: ({ row }) => (
        <a
          href={row.original.websiteURL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.websiteURL}
        </a>
      ),
    },
    {
      header: "Social Links",
      accessorKey: "socialLinks",
      Cell: ({ row }) => (
        <a
          href={row.original.socialLinks}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.socialLinks}
        </a>
      ),
    },
    // {
    //   header: "Default Day Schedule",
    //   accessorKey: "DefaultDaySchedule",
    //   size: 300,
    //   Cell: ({ row }) => (
    //     <div style={{ display: "flex", flexDirection: "column", gap: "4px"}}>
    //       {row.original.DefaultDaySchedule.map((schedule) => (
    //         <div key={schedule.dayId} style={{ display: "flex", gap: "8px" }}>
    //           <strong>{schedule.dayName}:</strong>
    //           {schedule.isDayOff ? (
    //             <span style={{ color: "red" }}>Day Off</span>
    //           ) : (
    //             <span>
    //               {moment(schedule.startTime, "HH:mm:ss").format("HH:mm")} -{" "}
    //               {moment(schedule.endTime, "HH:mm:ss").format("HH:mm")}
    //             </span>
    //           )}
    //         </div>
    //       ))}
    //     </div>
    //   ),
    // },
    {
      header: "Created At",
      accessorKey: "createdAt",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) =>
        <span>{dateFormat(row.original.createdAt, true)}</span>
      // new Date(row.original.createdAt).toLocaleString(),
    },
    {
      header: "Modified At",
      accessorKey: "modifiedAt",
      enableSorting: true,
      sortingFn: "datetime",
      Cell: ({ row }) =>
        <span>{dateFormat(row.original.modifiedAt, true)}</span>
      // row.original.modifiedAt
      //   ? new Date(row.original.modifiedAt).toLocaleString()
      //   : "N/A",
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,

      // Proper column width control
      size: 600, // used by MRT/TanStack table for layout
      muiTableHeadCellProps: { sx: { minWidth: 350, maxWidth: 520 } },
      muiTableBodyCellProps: { sx: { minWidth: 350, maxWidth: 520 } },

      Cell: ({ row }) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap", // allows wrapping if space too small
            gap: "0.5rem",
            justifyContent: "flex-start",
            alignItems: "center",
            minWidth: "350px", // ensures enough room for all buttons
          }}
        >
          {/* Edit button */}
          {useCheckUserPermission(route.BusinessOnboarding) && (
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                navigate(`${route.BusinessOnboarding}/${row.original.ID}`);
                console.log("Edit row:", row.original.ID);
              }}
            >
              <Edit className="custome-icon-size" />
            </button>
          )}

          {/* View button */}
          {useCheckUserPermission(route.BusinessOnboarding) && (
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                navigate(`/businesslistview/${row.original.ID}`);
                console.log("View row:", row.original.ID);
              }}
            >
              <Eye className="custome-icon-size" />
            </button>
          )}

          {/* Delete button */}
          {useCheckUserPermission(businessOnboardingDelete) && (
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => showConfirmationAlert(row.original.ID)}
            >
              <Trash2 className="custome-icon-size" />
            </button>
          )}

          {/* Download Excel */}
          <button
            onClick={() => {
              const id = row.original.ID;

              window.open(`/addMultiServices/${id}`, "_blank");
            }}
            className="btn btn-outline-primary btn-sm"
          >
            Add Service
          </button>
          <button
            onClick={() => {
              const id = row.original.ID;
              const businessName = row?._valuesCache?.businessName;
              const businessUniqueName = row?._valuesCache?.businessUniqueName;

              getBussinessCategories(id);
              handleDownload(id, businessName, businessUniqueName);
            }}
            className="btn btn-outline-primary btn-sm"
          >
            Download Excel
          </button>

          {/* Upload Service */}
          <div>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => {
                setSelectedBusinessId(row.original.ID); // store clicked business ID
                fileInputRef.current.click(); // open file selector
              }}
            >
              Upload Service
            </button>

            <input
              type="file"
              accept=".xlsx"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileUpload}
            />
          </div>
        </Box>
      ),
    },
  ];

  function mergeBusinessWithHours(businessList, hoursList) {
    // Group hours by businessId
    const hoursByBusiness = hoursList.reduce((acc, hour) => {
      if (!acc[hour.businessId]) {
        acc[hour.businessId] = [];
      }
      acc[hour.businessId].push({
        dayId: hour.dayId,
        dayName: hour.dayName,
        startTime: hour.startTime,
        endTime: hour.endTime,
        isDayOff: hour.isDayOff,
      });
      return acc;
    }, {});

    // Merge with business list
    return businessList.map((business) => ({
      ...business,
      DefaultDaySchedule: hoursByBusiness[business.ID] || [], // Add matched hours or an empty array
    }));
  }

  const prodcutDataListApi = async () => {
    setLoading(true)
    const response = await apiHandler({
      method: "GET",
      route: `Business/businessOnboardlist?businessId=${user_data?.businessId || 0
        }`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      const businessList = mergeBusinessWithHours(
        response.ResponseData[0],
        response.ResponseData[1]
      );
      setLoading(false)
      setProductlist(businessList);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    // ID: item?.ID,
    businessName: item?.businessName,
    businessTypeName: item?.businessTypeName,
    emailAddress: item?.emailAddress,
    businessAddress: item?.businessAddress,
    websiteURL: item?.websiteURL,
  }));
  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <HeaderModule
            refreshData={prodcutDataListApi}
            exportData={exportData}
            addMasterPageLink={route.BusinessOnboarding}
          />
          {/* Business  list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <CommonMaterialReactTable
                  columns={columns}
                  data={productlist}
                  columnRightPin={["actions"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessOnboardList;
